export default {
    customers: state => state.customers,
    activeCustomer: state => state.activeCustomer,
    manageCustomerDialog: state => state.manageCustomerDialog,
    manageDeleteCustomerDialog: state => state.manageDeleteCustomerDialog
}
